import { BRAND } from "@/content";

export default function Logo({ variant = "dark", className = "", size = "md" }) {
  const sizes = {
    sm: "w-24 max-h-10",
    md: "w-32 max-h-12",
    lg: "w-40 max-h-14",
    xl: "w-48 max-h-16",
  };
  const dimensions = sizes[size] || sizes.md;
  const src = "/brand/logo-transparent.png";

  return (
    <div
      className={`inline-flex items-center ${className}`}
      data-testid="brand-logo"
      aria-label={`${BRAND.companyEn} — ${BRAND.companyAr}`}
    >
      <img
        src={src}
        alt={BRAND.companyEn}
        className={`${dimensions} h-auto object-contain drop-shadow-[0_3px_12px_rgba(0,0,0,0.24)] ${
          variant === "dark"
            ? "[filter:brightness(1.22)_contrast(1.04)]"
            : "[filter:brightness(1.08)_contrast(1.03)]"
        }`}
        loading="eager"
        decoding="async"
      />
    </div>
  );
}
